import PropTypes from "prop-types";
import React, {Component} from "react";
import ButtonBase from '@material-ui/core/ButtonBase';
import {Container} from "./Container";
import {Link} from "react-router-dom";


// class definition
export class Button extends Component {

    static propTypes = {
        style: PropTypes.any,
        LinkTo: PropTypes.string,
        onClick: PropTypes.func,
    };

    static defaultProps = {
        LinkTo: "",
        onClick: () => undefined
    };

    render() {

        // resolve properties
        const {style, children, LinkTo, onClick} = this.props;

        if (!LinkTo) {
            // render view
            return (
                <ButtonBase onClick={onClick} style={Object.assign({}, styles.button, style)}>
                    <Container flex justify="center" alignItems="center" style={{height: "inherit"}}>
                        {children}
                    </Container>
                </ButtonBase>
            );
        }


        // render view
        return (
            <Link to={LinkTo} onClick={onClick} style={Object.assign({}, styles.button, style)}>
                <Container flex justify="center" alignItems="center" style={{height: "inherit"}}>
                    {children}
                </Container>
            </Link>
        );
    }
}

const styles = {
    button: {
        width: 200,
        height: 100,
        border: "solid 1px #ffd200",
        backgroundColor: "#333333"
    }
};



// WEBPACK FOOTER //
// ./src/components/Button.js